/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import UFOSegment from '@atlassian/jira-ufo-segment';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { usePlacementPreloadedData } from '@jira/post-office__post-office-provider-preload-placement/src/preload-placement.tsx';
import { PlacementFetchProvider } from '@jira/post-office__post-office-provider/src/placement-fetch-provider.tsx';
import { postOfficeNav4ProjectsSectionResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { DefaultMessagesResponse } from '@post-office/placement-common-v2/types';
import { SSRPlacement as Nav4ProjectsSectionSSR } from '@post-office/placements/nav-4-projects-section/frontend';
import React, { memo, useMemo } from 'react';

export const Nav4ProjectsSectionPlacement: React.MemoExoticComponent<() => React.JSX.Element> =
	memo((): React.JSX.Element => {
		const [preloadedInitialData] = usePlacementPreloadedData(postOfficeNav4ProjectsSectionResource);
		const memoizedPlacementProps = useMemo(
			() => ({
				// oxlint-disable-next-line typescript/consistent-type-assertions
				preloadedInitialData: preloadedInitialData as DefaultMessagesResponse | undefined,
			}),
			[preloadedInitialData],
		);

		return (
			<UFOSegment name="jira-growth-nav-4-projects-section">
				<JSErrorBoundary
					id="growthNav4ProjectsSection"
					packageName="@jira/growth__nav-4-projects-section"
					teamName="Sequoia"
					fallback="unmount"
				>
					<PlacementFetchProvider resource={postOfficeNav4ProjectsSectionResource}>
						<Nav4ProjectsSectionSSR {...memoizedPlacementProps} />
					</PlacementFetchProvider>
				</JSErrorBoundary>
			</UFOSegment>
		);
	});
